var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kye-upload-card",class:_vm.btnClass,style:(_vm.cardStyle)},[_c('i',{staticClass:"el-icon-loading"}),_vm._v(" "),_c('span',[_vm._v("上传中...")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/cache-loader/dist/cjs.js!./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-345613d0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/public/components/kye-upload/components/upload-load.vue
// module id = null
// module chunks = 